import React, { FC, useContext } from 'react';
import { DataRoomNdaSigner } from 'router/subrouters/DataRoom/models/DataRoomNDA';
import { getUserFullName, normalizeEmail } from 'utils';
import { DYNAMIC_TABLE_COLUMNS, FIXED_TABLE_COLUMNS } from './data';
import NdaStatusBadge from '../../DataRoomNdaStatusBadge';
import { Checkbox } from 'ncoded-component-library';
import DataRoomNdaTableProviderContext from '../../../providers/DataRoomNdaTableProvider/DataRoomNdaTableProvider.context';

export const getSignerInfo = (
  signer: DataRoomNdaSigner,
): { name: string; email: string } => {
  const { email, firstName, lastName } = signer?.user || {};

  return {
    email,
    name: getUserFullName(firstName, lastName),
  };
};

type CellProps = {
  signer: DataRoomNdaSigner;
  dataRoomNdaId?: string;
  isSelected?: boolean;
  updateSelected?: (signer: DataRoomNdaSigner) => void;
};

export const CheckboxCell: React.FC<CellProps> = ({
  signer,
  isSelected,
  updateSelected,
}) => {
  return (
    <div onClick={(e) => e.stopPropagation()}>
      <Checkbox checked={isSelected} onChange={() => updateSelected(signer)} />
    </div>
  );
};

const NameCell: FC<CellProps> = ({ signer }) => {
  const { name } = getSignerInfo(signer);

  return <div className="name-cell">{name}</div>;
};

const EmailCell: FC<CellProps> = ({ signer }) => {
  const { email } = getSignerInfo(signer);

  if (!email) return null;

  return <div className="email-cell">{normalizeEmail(email)}</div>;
};

const NDACell: FC<CellProps> = ({ signer, dataRoomNdaId }) => {
  const { dataRoomNdaSignings } = signer;

  const { openNdaDrawer } = useContext(DataRoomNdaTableProviderContext);

  const currNda = dataRoomNdaSignings.find(
    (el) => el.dataRoomNdaId === dataRoomNdaId,
  );

  if (!currNda) return null;

  return (
    <div className="nda-cell">
      <NdaStatusBadge
        status={currNda.status}
        signedDate={currNda.signedDate}
        sentDate={currNda.sentDate}
        rejectionReason={currNda.rejectionReason}
        envelopeTemplateName={currNda.dataRoomNda.name}
        onClick={() => openNdaDrawer(signer, currNda)}
      />
    </div>
  );
};

export const BODY_CONTENT_GENERATE: Record<
  string,
  (cellProps: CellProps) => React.ReactNode
> = {
  // [FIXED_TABLE_COLUMNS.CHECKBOX]: (cellProps: CellProps) => (
  //   <CheckboxCell {...cellProps} />
  // ),
  [FIXED_TABLE_COLUMNS.NAME]: (cellProps: CellProps) => (
    <NameCell {...cellProps} />
  ),
  [FIXED_TABLE_COLUMNS.EMAIL]: (cellProps: CellProps) => (
    <EmailCell {...cellProps} />
  ),
  [DYNAMIC_TABLE_COLUMNS.NDA]: (cellProps: CellProps) => (
    <NDACell {...cellProps} />
  ),
};
